import React, { useMemo } from 'react';

import { Grid, Text } from '@mantine/core';
import { useLocalization } from 'context/localization-context';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { AppointmentAthleteRetrieve } from 'types';

const AppointmentMainSection = ({
  appointmentData,
}: {
  appointmentData: AppointmentAthleteRetrieve;
}): JSX.Element => {
  const { dateTimeFormat } = useLocalization();

  const fullStartDate = new Date(`${appointmentData.startDate}T${appointmentData.startTime}`);

  const cancellationBeforeDate = `Before ${dayjs(fullStartDate)
    .subtract(
      appointmentData.cancellationSettings?.cancellationIntervalCount || 0,
      appointmentData.cancellationSettings?.cancellationInterval || 'minutes',
    )
    .format(dateTimeFormat)}`;

  const locationText = useMemo(() => {
    if (appointmentData.location && appointmentData.location.url) {
      return (
        <Text size='lg' color='gray.7' weight={700}>
          <Link target='_blank' rel='noopener noreferrer' to={appointmentData.location.url}>
            {appointmentData.location.name}
          </Link>
        </Text>
      );
    }
    if (appointmentData.location) {
      return (
        <Text size='lg' color='gray.7' weight={700}>
          {appointmentData.location.name}
        </Text>
      );
    }
    return '-';
  }, [appointmentData]);

  return (
    <Grid columns={6} align='center' gutter='xs'>
      <Grid.Col span={2}>
        <Text align='right' color='dimmed' fs='italic'>
          Location
        </Text>
      </Grid.Col>
      <Grid.Col span={4}>{locationText}</Grid.Col>

      <Grid.Col span={2}>
        <Text align='right' color='dimmed' fs='italic'>
          Cancellation
        </Text>
      </Grid.Col>
      <Grid.Col span={4}>
        <Text size='lg' color='gray.7' weight={700}>
          {cancellationBeforeDate}
        </Text>
      </Grid.Col>
    </Grid>
  );
};

export default AppointmentMainSection;
